var Btn = /** @class */ (function () {
    function Btn() {
        this.disabled = false;
    }
    return Btn;
}());
export { Btn };
//# sourceMappingURL=button.js.map